import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why the digital book revolution is stupid",
  "description": "",
  "published": "2009-12-08T00:00:00.000Z",
  "redirect_from": ["/blog/why-the-digital-book-revolution-is-stupid/swizec/944"],
  "categories": "Arts, E-book, food for thought, intrigues, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://cache.gawker.com/assets/images/4/2009/12/500x_library-image-rendering.jpg",
        "alt": null,
        "title": "CGI future Stockholm library"
      }}></img>{`They say the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/E-book",
        "title": "E-book"
      }}>{`digital book`}</a>{` revolution is upon us, that in a few more years everybody reading a dead-tree book will be silly, people with bookshelves fetishists and soon after that we'll arrange `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Witch-hunt",
        "title": "Witch-hunt"
      }}>{`witch hunts`}</a>{` against anyone even thinking about killing a tree for t heir amusement.`}</p>
    <p>{`They also say 2005`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      